export default __webpack_public_path__ + "static/chat-dark-77da8943ecfcb92dabf292b8b3fcfec3.png";